import * as React from 'react';
import {CSSProperties} from "react";
import styled from 'styled-components';
import Colours from '../State/Colours';
import devices from '../State/Devices';
import { IUsageSelector } from '../Types/Datasources';
import {
    ISelection,
} from '../Types/Model';
import LayoutSingleColumn from './Layout/LayoutSingleColumn';
import { Input } from './MlrForm';
import { InterfaceOption, Select } from './Select';
import Tooltip from './Tooltip';

interface IUsageSelectorComponent extends IUsageSelector {
    title: string
    headers: [React.ReactNode, React.ReactNode]
    defaultOption?: InterfaceOption
    onAdd: (text: string) => void
    tooltip?: string
}

interface InterfaceAddOption {
    options: string[]
    defaultOption?: InterfaceOption
    onChange: (e: React.FormEvent<HTMLSelectElement>) => void
};


interface InterfaceEditField extends ISelection {
    options: string[]
    tooltip?: string
    onChangeName: (e: React.FormEvent<HTMLSelectElement>) => void
    onChangeValue: (e: React.FormEvent<HTMLInputElement>) => void
    rowNumber: number
}

const AddOption = ({ options, defaultOption, onChange }: InterfaceAddOption) => (
    <React.Fragment>
        <Select
            defaultOption={defaultOption || { id: 'Add another +', label: 'Add another +', value: '' }}
            options={options.map(text => ({ id: text, label: text, value: text }))}
            selectedValue={{ id: 'Add another +', label: 'Add another +', value: '' }}
            onChange={onChange}
        />
    </React.Fragment>
);

const LayoutEditUsageColumns = styled.div`
    display: -ms-grid;
    display: grid;
    grid-template-columns: 1fr 140px 140px;
    -ms-grid-columns: 1fr 140px 140px;
    grid-row-gap: 8px; /* TODO */
    grid-column-gap: 8px;

    strong {
        font-size: 12px;
    }

    strong.total, span.total {
        text-align: right;
        color: ${Colours.primary};
        align-self: center;
        -ms-grid-row-align: center;
        display: block;
    }

    @media ${devices.laptop} {
        grid-template-columns: 1fr 70px 90px;
        -ms-grid-columns: 1fr 70px 90px;
    }
    
    & *:nth-child(3n) { -ms-grid-column: 3; }
    & *:nth-child(3n+1) { -ms-grid-column: 1; }
    & *:nth-child(3n+2) { -ms-grid-column: 2; }
    
    & strong {
        display: block;
    }
`;

const ToolTipContainer = styled.span`
    display: -ms-grid;            
    display: grid;
    grid-template-columns: auto 1fr;
    -ms-grid-columns: auto 1fr;
    align-items: center;

    @media ${devices.laptop} {
        grid-template-columns: 1fr;
        -ms-grid-columns: 1fr;

        /* Hide the tooltip */
        span:nth-child(1) {
            display: none;
        }
    }
`;

const EditSelection = ({ type, options, name, value, total, tooltip, onChangeName, onChangeValue, rowNumber }: InterfaceEditField) => {
    const filteredOptions = options.filter(item => item !== name);

    const rowStyle = { msGridRow: rowNumber } as CSSProperties;

    return (
        <React.Fragment>
            <Select
                defaultOption={{ id: name, label: name, value: name }}
                options={filteredOptions.map(text => ({ id: text, value: text, label: text}))}
                selectedValue={{ id: name, label: name, value: name }}
                onChange={onChangeName}
                style={{ display: 'block', width: '100%', ...rowStyle }}
            />
            {tooltip ? (
                <ToolTipContainer style={rowStyle}>
                    <Tooltip position="left" text={tooltip}/>
                    <Input type="number" value={value} onChange={onChangeValue}/>
                </ToolTipContainer>
            ) : (
                <Input type="number" value={value} onChange={onChangeValue} style={rowStyle}/>
            )}
            <span className="total" style={rowStyle}>{total}</span>
        </React.Fragment>
    )
};

const HeaderRow = styled.div`
    font-weight: bold;
    font-size: 1.1em;
`;

export default ({
        defaultOption,
        headers,
        onAdd,
        onChangeName,
        onChangeValue,
        options,
        selections,
        title,
        tooltip,
    }: IUsageSelectorComponent) => {
    const onAddEvent = (e: React.FormEvent<HTMLSelectElement>) => onAdd(e.currentTarget.value);

    return (
        <div>
            {title.length > 0 && (
                <HeaderRow>
                    <span>{title}</span>
                    {tooltip && <Tooltip text={tooltip} position="right"/>}
                </HeaderRow>
            )}

            <LayoutEditUsageColumns>
                {selections.length > 0 && (
                    <React.Fragment>    
                        <strong style={{ msGridColumn: 1} as CSSProperties} >{headers[0]}</strong>
                        <strong style={{ msGridColumn: 2} as CSSProperties} >{headers[1]}</strong>
                        <strong style={{ msGridColumn: 3} as CSSProperties} className="total">&nbsp;</strong>
                    </React.Fragment>
                )}
                {selections.map((item, index) => {
                    const onChangeNameEvent = (e: React.FormEvent<HTMLSelectElement>) => onChangeName(index, e.currentTarget.value);
                    const onChangeNameValue = (e: React.FormEvent<HTMLInputElement>) => onChangeValue(index, e.currentTarget.value);

                    return (
                        <EditSelection 
                            key={item.name + index} 
                            onChangeName={onChangeNameEvent}
                            onChangeValue={onChangeNameValue}
                            options={options} 
                            tooltip={item.tooltip}
                            rowNumber={index + 2}
                            {...item}
                        />
                    )
                })}
            </LayoutEditUsageColumns>

            <LayoutSingleColumn>
                <AddOption
                    options={options} 
                    defaultOption={defaultOption} 
                    onChange={onAddEvent}
                />
            </LayoutSingleColumn>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/Components/UsageSelector.tsx